module.exports = __webpack_public_path__ + "d5e590eff8349ff107ce3d71ef11aeb6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/microsoft_2022_chart.png
// module id = 1696
// module chunks = 0